import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts&setup=true"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=8c40a43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c40a43e"]])

export default __exports__